import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUserStore = create(persist(
    (set) => ({
        userData: null,
        setUserData: (data) => set({ userData: data }),
        clearUserData: () => set({ userData: null }),
    }),
    {
        name: 'user-store', // key in localStorage
    }
));

export default useUserStore;